import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import * as Alasql from 'alasql'
import momenttz from 'moment-timezone'
import { withStyles } from 'material-ui/styles'
import Select from 'material-ui/Select'
import { FormControl } from 'material-ui/Form'
import { MenuItem } from 'material-ui/Menu'
import IconButton from 'material-ui/IconButton'
import AddIcon from 'material-ui-icons/Add'
import EnergyIcon from 'material-ui-icons/BatteryCharging60'
import PlayArrowIcon from 'material-ui-icons/PlayArrow'

import { GC_USER_ID, ENERGY_TRACKER_ID } from '@/constants'

import { graphql } from 'react-apollo'

import { eventsQuery } from '@/graphql/queries/event'
import { routinesQuery } from '@/graphql/queries/routine'
import {
  newRoutine,
  updateRoutine,
  addToRoutinesOnRoutine,
  deleteRoutine
} from '@/graphql/mutations/routine'

import TrackersModal from '../modals/Trackers'
import EventViewModal from '../modals/EventView'
import EventEditModal from '../modals/EventEdit'
import RoutinesModal from '../modals/Routines'
import Loading from '../modals/Loading'

const energyTrackerId = global.localStorage.getItem(ENERGY_TRACKER_ID)

const styles = theme => ({
  loadingProgress: {
    margin: theme.spacing.unit * 2,
    color: 'lightgrey'
  },
  iconFixed: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit,
    position: 'fixed',
    right: 5,
    zIndex: 100
  },
  routineFixed: {
    margin: theme.spacing.unit,
    position: 'absolute',
    left: 30,
    top: 168,
    zIndex: 100
  },
  iconBtnCurrentBook: {
    color: 'lightgrey',
    height: 30,
    width: 30
  },
  divChartBurnDown: {
    marginLeft: -theme.spacing.unit * 2,
    height: 650
  },
  textInput: {
    color: 'silver',
    fontSize: 9
  }
})

var minTime = moment()
var maxTime = moment()
var maxTimeHappened = moment()

@graphql(newRoutine, {
  name: 'newRoutine',
  options: {
    refetchQueries: ['routinesQuery']
  }
})
@graphql(updateRoutine, {
  name: 'updateRoutine',
  options: {
    refetchQueries: ['routinesQuery']
  }
})
@graphql(addToRoutinesOnRoutine, {
  name: 'addToRoutinesOnRoutine',
  options: {
    refetchQueries: ['routinesQuery']
  }
})
@graphql(deleteRoutine, {
  name: 'deleteRoutine',
  options: {
    refetchQueries: ['routinesQuery']
  }
})
@graphql(eventsQuery, {
  name: 'eventsQuery',
  options: ownProps => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID),
      dayS: ownProps.dayS,
      dayE: ownProps.dayE
    },
    refetchQueries: ['eventsQuery']
  })
})
@graphql(routinesQuery, {
  name: 'routinesQuery',
  options: ownProps => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID),
      dayS: ownProps.dayS,
      dayE: ownProps.dayE
    },
    refetchQueries: ['routinesQuery']
  })
})
@withStyles(styles)
export default class AlchemyTimelineDaily extends Component {
  constructor(props) {
    super(props)
    this.state = {
      apiData: '',
      apiRankData: '',
      apiTopRankData: '',

      apiErr: '',
      apiTopErr: '',
      addErr: '',

      apiLoading: false,
      apiTopLoading: false,
      loadingEvent: false,
      loadingAddTo: false,
      loadingCreate: false,
      loadingDel: false,

      OpenView: false,
      OpenAdd: false,
      OpenTimer: false,
      OpenTrackers: false,
      OpenRoutines: false,
      origin: '',

      event: '',
      routine: '',
      oneRoutine: '',
      groups: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.routinesQuery !== this.props.routinesQuery) {
      var routines = nextProps.routinesQuery.allRoutines
      if (routines) {
        var customRoutines = routines.filter(
          e => e.routines && e.routines.length > 0
        )
        if (customRoutines.length > 0) {
          this.setState({
            routine: customRoutines[0],
            oneRoutine: customRoutines[0].routines[0]
          })
          if (customRoutines[0].groups && customRoutines[0].groups.length > 0) {
            this.setState({ groups: customRoutines[0].groups })
          } else {
            this.setState({ groups: '' })
          }
        } else {
          var defaultRoutines = routines.filter(
            e =>
              e.frequency &&
              e.frequency.includes(
                moment(new Date(this.props.dayS)).format('ddd')
              )
          )
          if (defaultRoutines.length > 0) {
            this.setState({ routine: defaultRoutines[0], oneRoutine: '' })
            if (
              defaultRoutines[0].groups &&
              defaultRoutines[0].groups.length > 0
            ) {
              this.setState({ groups: defaultRoutines[0].groups })
            } else {
              this.setState({ groups: '' })
            }
          } else {
            this.setState({ routine: '', oneRoutine: '' })
          }
        }
      }
    }
  }

  componentDidMount() {
    this.setState({ apiLoading: true, apiTopLoading: true })
    fetch(
      'https://cors-anywhere.herokuapp.com/https://www.rescuetime.com/anapi/data?key=B6396Qln0RBqiSENMdfSXWs3XP3HUIrvAdmjMPOt&perspective=interval&restrict_kind=activity&interval=minute&restrict_begin=' +
        this.props.dayS +
        '&restrict_end=' +
        this.props.dayS +
        '&format=json'
    )
      .then(response => response.json())
      .then(response => {
        if (!response.rows) {
          console.log('No api data fetched.')
        } else {
          this.setState({
            apiData: response.rows
          })
        }
      })
      .catch(error => console.log('API Data Fetching failed: ' + error.message))

    fetch(
      'https://cors-anywhere.herokuapp.com/https://www.rescuetime.com/anapi/data?key=B6396Qln0RBqiSENMdfSXWs3XP3HUIrvAdmjMPOt&perspective=rank&restrict_kind=activity&restrict_begin=' +
        this.props.dayS +
        '&restrict_end=' +
        this.props.dayS +
        '&format=json'
    )
      .then(response => response.json())
      .then(response => {
        if (!response.rows) {
          console.log('No api rank data fetched.')
        } else {
          this.setState({
            apiRankData: response.rows,
            apiLoading: false
          })
        }
      })
      .catch(error =>
        this.setState({ apiErr: error.message, apiLoading: false })
      )

    fetch(
      'https://cors-anywhere.herokuapp.com/https://www.rescuetime.com/anapi/data?key=B6396Qln0RBqiSENMdfSXWs3XP3HUIrvAdmjMPOt&perspective=rank&restrict_kind=productivity&restrict_begin=' +
        this.props.dayS +
        '&restrict_end=' +
        this.props.dayS +
        '&format=json'
    )
      .then(response => response.json())
      .then(response => {
        if (!response.rows) {
          console.log('No api top rank data fetched.')
        } else {
          this.setState({
            apiTopRankData: response.rows,
            apiTopLoading: false
          })
        }
      })
      .catch(error =>
        this.setState({ apiTopErr: error.message, apiTopLoading: false })
      )
  }

  componentDidUpdate(prevProps) {
    if (this.props.dayS !== prevProps.dayS) {
      this.setState({
        apiData: '',
        apiRankData: '',
        apiTopRankData: '',
        apiLoading: true,
        apiTopLoading: true
      })
      fetch(
        'https://cors-anywhere.herokuapp.com/https://www.rescuetime.com/anapi/data?key=B6396Qln0RBqiSENMdfSXWs3XP3HUIrvAdmjMPOt&perspective=interval&restrict_kind=activity&interval=minute&restrict_begin=' +
          this.props.dayS +
          '&restrict_end=' +
          this.props.dayS +
          '&format=json'
      )
        .then(response => response.json())
        .then(response => {
          if (!response.rows) {
            console.log('No data fetched.')
          } else {
            this.setState({
              apiData: response.rows
            })
          }
        })
        .catch(error =>
          console.log('API Data Fetching failed: ' + error.message)
        )

      fetch(
        'https://cors-anywhere.herokuapp.com/https://www.rescuetime.com/anapi/data?key=B6396Qln0RBqiSENMdfSXWs3XP3HUIrvAdmjMPOt&perspective=rank&restrict_kind=activity&restrict_begin=' +
          this.props.dayS +
          '&restrict_end=' +
          this.props.dayS +
          '&format=json'
      )
        .then(response => response.json())
        .then(response => {
          if (!response.rows) {
            console.log('No api rank data fetched.')
          } else {
            this.setState({
              apiRankData: response.rows,
              apiLoading: false
            })
          }
        })
        .catch(error =>
          this.setState({ apiErr: error.message, apiLoading: false })
        )

      fetch(
        'https://cors-anywhere.herokuapp.com/https://www.rescuetime.com/anapi/data?key=B6396Qln0RBqiSENMdfSXWs3XP3HUIrvAdmjMPOt&perspective=rank&restrict_kind=productivity&restrict_begin=' +
          this.props.dayS +
          '&restrict_end=' +
          this.props.dayS +
          '&format=json'
      )
        .then(response => response.json())
        .then(response => {
          if (!response.rows) {
            console.log('No api top rank data fetched.')
          } else {
            this.setState({
              apiTopRankData: response.rows,
              apiTopLoading: false
            })
          }
        })
        .catch(error =>
          this.setState({ apiTopErr: error.message, apiTopLoading: false })
        )
    }
  }

  timelineDaily = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []

    const keys = Object.keys(data)

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g key={`piece-${key}`}>
          {column.pieceData.map((e, index) => (
            <g
              key={`stack-rect-${index}`}
              cursor={'pointer'}
              onClick={() => this.handleOpenView(e.data)}
            >
              <rect
                key={`rect-${key}`}
                fill={
                  e.data.project
                    ? e.data.project.color
                    : e.data.tracker
                      ? e.data.tracker.type === 'energy' ||
                        e.data.tracker.type === 'bodyweight'
                        ? 'white'
                        : e.data.tracker.color
                      : e.data.color ? e.data.color : ''
                }
                stroke={
                  (e.data.tracker && e.data.tracker.type === 'energy') ||
                  (e.data.tracker && e.data.tracker.type === 'bodyweight')
                    ? e.data.tracker && e.data.tracker.color
                    : ''
                }
                opacity={
                  e.data.tracker && e.data.tracker.type === 'energy'
                    ? 1
                    : e.data.eventType.includes('happened') ||
                      e.data.eventType.includes('Done')
                      ? 0.7
                      : 0.35
                }
                width={5}
                height={
                  e.data.tracker && !e.data.tracker.isDuration
                    ? 5
                    : rScale(new Date(e.data.completedAt)) >
                      rScale(new Date(e.data.startedAt))
                      ? 5
                      : moment(new Date(e.data.completedAt)).format('l') ===
                        moment(new Date(e.data.startedAt)).format('l')
                        ? rScale(new Date(e.data.startedAt)) -
                          rScale(new Date(e.data.completedAt))
                        : moment(new Date(e.data.completedAt)).format('l') ===
                          moment(new Date(this.props.dayS))
                            .add(1, 'day')
                            .format('l')
                          ? rScale(new Date(e.data.startedAt)) -
                            rScale(new Date(this.props.dayE))
                          : e.data.tracker && e.data.tracker.type !== 'sleep'
                            ? rScale(new Date(this.props.dayS)) -
                              rScale(new Date(e.data.completedAt))
                            : rScale(
                                new Date(
                                  moment(new Date(this.props.dayS)).add(
                                    4,
                                    'hours'
                                  )
                                )
                              ) - rScale(new Date(e.data.completedAt))
                }
                x={
                  e.data.tracker && e.data.tracker.type === 'energy'
                    ? 160 + e.data.options.value * 10
                    : e.data.eventType.includes('plan') &&
                      !e.data.eventType.includes('happened')
                      ? 1
                      : e.data.eventType === 'routine'
                        ? 110
                        : e.data.eventType === 'dayPlan2_v2'
                          ? 70
                          : e.data.eventType === 'dayPlan2_v3'
                            ? 30
                            : e.data.dataOrigin === 'api_rescureTime'
                              ? 270
                              : 160
                }
                y={
                  moment(new Date(e.data.startedAt)).format('l') ===
                  moment(new Date(this.props.dayS)).format('l')
                    ? rScale(maxTime) -
                      rScale(new Date(e.data.startedAt)) +
                      rScale(minTime)
                    : e.data.tracker && e.data.tracker.type !== 'sleep'
                      ? rScale(maxTime) -
                        rScale(new Date(this.props.dayS)) +
                        rScale(minTime)
                      : rScale(maxTime) -
                        rScale(
                          new Date(
                            moment(new Date(this.props.dayS)).add(4, 'hours')
                          )
                        ) +
                        rScale(minTime)
                }
                rx={
                  (e.data.tracker && e.data.tracker.type === 'energy') ||
                  (e.data.tracker && e.data.tracker.type === 'checked')
                    ? 3
                    : 1.5
                }
                ry={
                  (e.data.tracker && e.data.tracker.type === 'energy') ||
                  (e.data.tracker && e.data.tracker.type === 'checked')
                    ? 3
                    : 1.5
                }
              />
              {e.data.eventType.includes('happened') &&
                e.data.dataOrigin !== 'api_rescureTime' &&
                e.data.tracker.type !== 'energy' && (
                  <text
                    key={`piece-text-${key}`}
                    x={e.data.tracker.type === 'bodyweight' ? 166 : 170}
                    y={
                      moment(new Date(e.data.completedAt)).format('l') ===
                      moment(new Date(e.data.startedAt)).format('l')
                        ? rScale(maxTime) -
                          rScale(new Date(e.data.startedAt)) +
                          rScale(minTime) +
                          adjustedSize[0] / 42 +
                          (rScale(new Date(e.data.startedAt)) -
                            rScale(new Date(e.data.completedAt))) /
                            2
                        : moment(new Date(e.data.completedAt)).format('l') ===
                          moment(new Date(this.props.dayS))
                            .add(1, 'day')
                            .format('l')
                          ? rScale(maxTime) -
                            rScale(new Date(e.data.startedAt)) +
                            rScale(minTime) +
                            adjustedSize[0] / 42 +
                            (rScale(new Date(e.data.startedAt)) -
                              rScale(new Date(this.props.dayE))) /
                              2
                          : e.data.tracker.type !== 'sleep'
                            ? rScale(maxTime) -
                              rScale(new Date(this.props.dayS)) +
                              rScale(minTime) +
                              adjustedSize[0] / 42 +
                              (rScale(new Date(this.props.dayS)) -
                                rScale(new Date(e.data.completedAt))) /
                                2
                            : rScale(maxTime) -
                              rScale(
                                new Date(
                                  moment(new Date(this.props.dayS)).add(
                                    4,
                                    'hours'
                                  )
                                )
                              ) +
                              rScale(minTime) +
                              adjustedSize[0] / 42 +
                              (rScale(
                                new Date(
                                  moment(new Date(this.props.dayS)).add(
                                    4,
                                    'hours'
                                  )
                                )
                              ) -
                                rScale(new Date(e.data.completedAt))) /
                                2
                    }
                    fontSize={adjustedSize[0] / 30}
                    fill={'lightgrey'}
                  >
                    {e.data.tracker.type === 'reading'
                      ? e.data.options.value +
                          ' pages - ' +
                          e.data.minutes +
                          'm | ' +
                          e.data.book && e.data.book.name
                      : e.data.tracker.type === 'sleep'
                        ? e.data.options.isNap
                          ? e.data.minutes + 'm Nap '
                          : parseFloat(e.data.minutes / 60, 10).toFixed(1) +
                            'h - ' +
                            e.data.options.value +
                            '% | ' +
                            e.data.options.brianClearness
                        : e.data.tracker.type === 'bodyweight'
                          ? '•••••••• ' + e.data.options.value + ' LB'
                          : e.data.tracker.type === 'project' && e.data.task
                            ? e.data.minutes +
                              'm - ' +
                              e.data.tracker.name +
                              ' | ' +
                              e.data.task.name +
                              ' - ' +
                              e.data.subtask.name
                            : e.data.tracker.type === 'checked'
                              ? '•••••••• ✓' + e.data.tracker.name
                              : e.data.minutes + 'm | ' + e.data.tracker.name}
                  </text>
                )}
              {!e.data.eventType.includes('happened') && (
                <text
                  textAnchor={
                    e.data.eventType.includes('plan') ? 'start' : 'end'
                  }
                  key={`piece-text-${key}`}
                  x={
                    e.data.eventType === 'routine'
                      ? 110
                      : e.data.eventType === 'dayPlan2_v2'
                        ? 70
                        : e.data.eventType === 'dayPlan2_v3' ? 30 : 10
                  }
                  y={
                    moment(new Date(e.data.completedAt)).format('l') ===
                    moment(new Date(e.data.startedAt)).format('l')
                      ? rScale(maxTime) -
                        rScale(new Date(e.data.startedAt)) +
                        rScale(minTime) +
                        adjustedSize[0] / 42 +
                        (rScale(new Date(e.data.startedAt)) -
                          rScale(new Date(e.data.completedAt))) /
                          2
                      : moment(new Date(e.data.completedAt)).format('l') ===
                        moment(new Date(this.props.dayS))
                          .add(1, 'day')
                          .format('l')
                        ? rScale(maxTime) -
                          rScale(new Date(e.data.startedAt)) +
                          rScale(minTime) +
                          adjustedSize[0] / 42 +
                          (rScale(new Date(e.data.startedAt)) -
                            rScale(new Date(this.props.dayE))) /
                            2
                        : e.data.tracker &&
                          e.data.tracker.type === 'sleep' &&
                          rScale(maxTime) -
                            rScale(
                              new Date(
                                moment(new Date(this.props.dayS)).add(
                                  4,
                                  'hours'
                                )
                              )
                            ) +
                            rScale(minTime) +
                            adjustedSize[0] / 42 +
                            (rScale(
                              new Date(
                                moment(new Date(this.props.dayS)).add(
                                  4,
                                  'hours'
                                )
                              )
                            ) -
                              rScale(new Date(e.data.completedAt))) /
                              2
                  }
                  fontSize={adjustedSize[0] / 40}
                  fill={'lightgrey'}
                >
                  {e.data.eventType.includes('Done') || e.data.isCompleted
                    ? '✓ '
                    : e.data.eventType === 'routine'
                      ? e.data.name
                      : e.data.eventType.includes('plan')
                        ? e.data.book
                          ? e.data.book.name
                          : e.data.task
                            ? e.data.task.name
                            : e.data.tracker.name +
                              ' | ' +
                              parseInt(e.data.minutes / 60, 10) +
                              'h'
                        : ''}
                </text>
              )}
            </g>
          ))}
        </g>
      )

      renderedPieces.push(markObject)
    })

    return renderedPieces
  }

  handleOpenView = e => {
    this.setState({
      OpenView: true,
      event: e
    })
  }

  handleCloseView = () => {
    this.setState({
      OpenView: false
    })
  }

  handleCloseAdd = () => {
    this.setState({
      event: '',
      OpenAdd: false
    })
  }

  handleOpenTrackers = origin => {
    this.setState({
      OpenTrackers: true,
      origin: origin
    })
  }

  handleCloseTrackers = () => {
    this.setState({
      OpenTrackers: false
    })
  }

  handleOpenRoutines = () => {
    this.setState({
      OpenRoutines: true
    })
  }

  handleCloseRoutines = () => {
    this.setState({
      OpenRoutines: false
    })
  }

  handleEnergyAdd = trackerId => {
    var newEnergy = {
      startedAt: moment(new Date(this.props.dayS))
        .hour(moment().hour())
        .minute('0')
        .second('0'),
      dataOrigin: 'manualAdd',
      eventType: 'happened',
      options: {
        value: ''
      },
      tracker: {
        id: trackerId,
        type: 'energy'
      },
      mood: 0,
      comment: ''
    }

    this.setState({
      event: newEnergy,
      OpenAdd: true,
      origin: 'manualAdd'
    })
  }

  handleAddTo = (rid, id) => {
    this.setState({ loadingAddTo: true })
    this.props
      .addToRoutinesOnRoutine({
        variables: {
          routines1RoutineId: rid,
          routines2RoutineId: id
        }
      })
      .then(() => {
        this.setState({ loadingAddTo: false })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({ loadingAddTo: false })
      })
  }

  handleCreate = r => {
    this.setState({ loadingCreate: true })
    this.props
      .newRoutine({
        variables: {
          name: r.name,
          frequency: r.frequency,
          dateStart: this.props.dayS,
          type: 'one',
          userId: global.localStorage.getItem(GC_USER_ID)
        }
      })
      .then(data => {
        this.setState({ loadingCreate: false })
        this.handleAddTo(r.id, data.data.createRoutine.id)
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({ loadingCreate: false })
      })
  }

  handleDelete = () => {
    this.setState({ loadingDel: true })
    this.props
      .deleteRoutine({
        variables: {
          id: this.state.oneRoutine.id
        }
      })
      .then(() => {
        this.setState({
          loadingDel: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({
          loadingDel: false
        })
      })
  }

  handleChange = name => event => {
    switch (name) {
      case 'routineId':
        if (event.target.value === 'addRoutine') {
          this.handleOpenRoutines()
        } else {
          var r = JSON.parse(event.target.value)
          if (this.state.oneRoutine) {
            this.handleCreate(r)
            this.handleDelete()
          } else {
            this.handleCreate(r)
          }
        }
        break

      default:
        break
    }
  }

  render() {
    const { classes } = this.props
    if (this.props.eventsQuery.loading) {
      return <Loading />
    }
    if (this.props.routinesQuery.loading) {
      return <Loading />
    }

    var eventsDaily = []
    if (this.props.eventsQuery.allEvents) {
      this.props.eventsQuery.allEvents.map(e => eventsDaily.push(e))
    }

    if (this.state.groups && this.state.groups.length > 0) {
      this.state.groups.forEach(e => {
        var rS = momenttz.tz(e.startedAt, 'America/Los_Angeles')
        var rE = momenttz.tz(e.completedAt, 'America/Los_Angeles')
        var ds = moment(new Date(rE.format('l'))).diff(
          moment(new Date(rS.format('l'))),
          'days'
        )
        if (ds === 1) {
          var newGroup1 = {
            id: e.id,
            name: e.name,
            startedAt: moment(new Date(this.props.dayS))
              .subtract(1, 'day')
              .hour(rS.hour())
              .minute(rS.minute())
              .second(rS.second())
              .format(),
            completedAt: moment(new Date(this.props.dayS))
              .hour(rE.hour())
              .minute(rE.minute())
              .second(rE.second())
              .format(),
            minutesTotal: e.minutesTotal,
            isStared: e.isStared,
            isDuration: e.isDuration,
            isPublic: e.isPublic,
            isCompleted: e.isCompleted,
            trackers: e.trackers,
            eventType: 'routine',
            color: e.color,
            type: e.type
          }

          var newGroup2 = {
            id: e.id,
            name: e.name,
            startedAt: moment(new Date(this.props.dayS))
              .hour(rS.hour())
              .minute(rS.minute())
              .second(rS.second())
              .format(),
            completedAt: moment(new Date(this.props.dayS))
              .add(1, 'day')
              .hour(rE.hour())
              .minute(rE.minute())
              .second(rE.second())
              .format(),
            minutesTotal: e.minutesTotal,
            isStared: e.isStared,
            isDuration: e.isDuration,
            isPublic: e.isPublic,
            isCompleted: e.isCompleted,
            trackers: e.trackers,
            eventType: 'routine',
            color: e.color,
            type: e.type
          }
          if (e.groups.length > 0) {
            newGroup1.id = e.groups[0].id
            newGroup1.startedAt = e.groups[0].startedAt
            newGroup1.completedAt = e.groups[0].completedAt
            newGroup1.minutesTotal = e.groups[0].minutesTotal
            newGroup1.isCompleted = e.groups[0].isCompleted
            newGroup1.type = e.groups[0].type
            eventsDaily.push(newGroup1)
            newGroup2.id = e.groups[0].id
            newGroup2.startedAt = e.groups[0].startedAt
            newGroup2.completedAt = e.groups[0].completedAt
            newGroup2.minutesTotal = e.groups[0].minutesTotal
            newGroup2.isCompleted = e.groups[0].isCompleted
            newGroup2.type = e.groups[0].type
            eventsDaily.push(newGroup2)
          } else {
            eventsDaily.push(newGroup1)
            eventsDaily.push(newGroup2)
          }
        } else if (ds === 0) {
          var newGroup = {
            id: e.id,
            name: e.name,
            startedAt: moment(new Date(this.props.dayS))
              .hour(rS.hour())
              .minute(rS.minute())
              .second(rS.second())
              .format(),
            completedAt: moment(new Date(this.props.dayS))
              .hour(rE.hour())
              .minute(rE.minute())
              .second(rE.second())
              .format(),
            minutesTotal: e.minutesTotal,
            isStared: e.isStared,
            isDuration: e.isDuration,
            isPublic: e.isPublic,
            isCompleted: e.isCompleted,
            trackers: e.trackers,
            eventType: 'routine',
            color: e.color,
            type: e.type
          }
          if (e.groups.length > 0) {
            newGroup.id = e.groups[0].id
            newGroup.startedAt = e.groups[0].startedAt
            newGroup.completedAt = e.groups[0].completedAt
            newGroup.minutesTotal = e.groups[0].minutesTotal
            newGroup.isCompleted = e.groups[0].isCompleted
            newGroup.type = e.groups[0].type
            eventsDaily.push(newGroup)
          } else {
            eventsDaily.push(newGroup)
          }
        } else {
          console.log('Some event is longer than 1 day!')
        }
      })
    }

    //add api data
    if (this.state.apiData) {
      this.state.apiData.forEach(e =>
        eventsDaily.push({
          id: 'rescure-time-data',
          startedAt: momenttz.tz(e[0], 'America/Los_Angeles').format(),
          completedAt: momenttz
            .tz(e[0], 'America/Los_Angeles')
            .add(e[1], 'seconds')
            .format(),
          eventType: 'happened',
          dataOrigin: 'api_rescureTime',
          minutes: parseInt(e[1] / 60, 10),
          tracker: {
            name: e[3],
            color:
              e[5] === 2
                ? 'rgba(147, 112, 219,0.6)'
                : e[5] === 1
                  ? 'rgba(100,149,237,0.3)'
                  : e[5] === 0
                    ? 'rgba(128,128,128,0.4)'
                    : e[5] === -1
                      ? 'rgba(255,105,180,0.6)'
                      : e[5] === -2
                        ? 'rgba(255,0,0,0.4)'
                        : 'rgba(211,211,211,0.6)',
            isDuration: true
          }
        })
      )
    }

    // calc max and min time
    var eventStartTimes = []

    eventsDaily.forEach(e => {
      eventStartTimes.push(moment(new Date(e.startedAt)))
    })

    minTime = moment.min(eventStartTimes)
    maxTime = moment(new Date(this.props.dayE))

    var eventEndTimesHappened = []
    var eHappened = eventsDaily.filter(
      e =>
        e.eventType.includes('happened') &&
        e.dataOrigin !== 'api_rescureTime' &&
        moment(new Date(e.completedAt)).format('l') ===
          moment(new Date(this.props.dayS)).format('l')
    )
    if (eHappened.length > 0) {
      eHappened.forEach(e => {
        eventEndTimesHappened.push(moment(new Date(e.completedAt)))
      })
      maxTimeHappened = moment.max(eventEndTimesHappened)
    } else {
      maxTimeHappened = moment(new Date(this.props.dayS))
        .hour(moment().hour())
        .minute(moment().minute())
        .second(moment().second())
    }

    var sleeps = eventsDaily.filter(
      e =>
        e.tracker &&
        e.tracker.type === 'sleep' &&
        moment(new Date(e.startedAt)).format('l') ===
          moment(new Date(e.completedAt)).format('l') &&
        e.options &&
        !e.options.isNap
    )

    if (sleeps.length === 0) {
      minTime = moment(new Date(this.props.dayS)).add(5, 'hours')
    } else {
      minTime = moment(new Date(this.props.dayS)).add(1, 'hour')
    }

    //add api summary data: rank activity
    var apiDataRank = []
    if (this.state.apiRankData) {
      this.state.apiRankData.forEach(e =>
        apiDataRank.push({
          type: e[3],
          color:
            e[5] === 2
              ? 'rgba(147, 112, 219,0.6)'
              : e[5] === 1
                ? 'rgba(100,149,237,0.3)'
                : e[5] === 0
                  ? 'rgba(128,128,128,0.4)'
                  : e[5] === -1
                    ? 'rgba(255,105,180,0.6)'
                    : e[5] === -2
                      ? 'rgba(255,0,0,0.4)'
                      : 'rgba(211,211,211,0.6)',
          mins: parseInt(e[1] / 60, 10)
        })
      )
    }
    var offTrackMins =
      24 * 60 -
      apiDataRank.reduce(function(cnt, o) {
        return cnt + o.mins
      }, 0)

    if (offTrackMins > 0) {
      apiDataRank.push({
        type: 'no tracking',
        color: 'white',
        mins: offTrackMins
      })
    }

    //add api summary data: rank main productivity category
    var apiDataRankTop = []
    if (this.state.apiTopRankData) {
      this.state.apiTopRankData.forEach(e =>
        apiDataRankTop.push({
          type: e[3],
          color:
            e[3] === 2
              ? 'rgba(147, 112, 219,0.6)'
              : e[3] === 1
                ? 'rgba(100,149,237,0.3)'
                : e[3] === 0
                  ? 'rgba(128,128,128,0.4)'
                  : e[3] === -1
                    ? 'rgba(255,105,180,0.6)'
                    : e[3] === -2
                      ? 'rgba(255,0,0,0.4)'
                      : 'rgba(211,211,211,0.6)',
          mins: parseInt(e[1] / 60, 10)
        })
      )
    }
    var offTrackMinsTop =
      24 * 60 -
      apiDataRankTop.reduce(function(cnt, o) {
        return cnt + o.mins
      }, 0)

    if (offTrackMins > 0) {
      apiDataRankTop.push({
        type: 'no tracking',
        color: 'white',
        mins: offTrackMinsTop
      })
    }
    var happenedEvents = ''
    if (this.props.eventsQuery.allEvents) {
      happenedEvents = this.props.eventsQuery.allEvents.filter(
        e =>
          e.eventType.includes('happened') &&
          moment(new Date(e.completedAt)).format('l') ===
            moment(new Date(this.props.dayS)).format('l')
      )
    }

    var dailyPieData = []
    //var dailyPieCatData = []
    if (happenedEvents && happenedEvents.length > 0) {
      happenedEvents.forEach(e => {
        dailyPieData.push({
          minutes: e.minutes,
          color: e.tracker.color,
          type: e.tracker.name
        })
        /*
        dailyPieCatData.push({
          minutes: e.minutes,
          color: e.tracker.color,
          type: e.tracker.category
        })
        */
      })
    }

    var dailyPie = Alasql(
      'SELECT type, color, SUM(CAST([minutes] AS INT)) AS [minutes]  FROM ? GROUP BY type, color',
      [dailyPieData]
    )
    /*
    var dailyPieCat = Alasql(
      'SELECT type, color, SUM(CAST([minutes] AS INT)) AS [minutes]  FROM ? GROUP BY type, color',
      [dailyPieCatData]
    ) */

    var offTrackMinsHappened =
      24 * 60 -
      dailyPie.reduce(function(cnt, o) {
        return cnt + o.minutes
      }, 0)

    if (offTrackMinsHappened > 0) {
      dailyPie.push({
        minutes: offTrackMinsHappened,
        color: 'white',
        type: 'no tracking'
      })
    }
    var dailyPieCat = []
    var mins2 = 0
    var mins1 = 0
    var mins0 = 0
    var mins1n = 0
    var mins2n = 0
    var minsP = 0
    var minsW = 0
    if (happenedEvents && happenedEvents.length > 0) {
      happenedEvents.forEach(e => {
        if (e.tracker.category === 'Very Productive') {
          mins2 += e.minutes
        }
        if (e.tracker.category === 'Productive') {
          mins1 += e.minutes
        }
        if (e.tracker.category === 'Maintenance') {
          mins0 += e.minutes
        }
        if (e.tracker.category === 'Distracting') {
          mins1n += e.minutes
        }
        if (e.tracker.category === 'Very Distracting') {
          mins2n += e.minutes
        }
        if (e.tracker.category === 'Personal') {
          minsP += e.minutes
        }
        if (e.tracker.category === 'Workout') {
          minsW += e.minutes
        }
      })
    }
    dailyPieCat.push(
      {
        minutes: mins2,
        color: 'rgba(147, 112, 219,0.6)',
        type: 'Very Productive'
      },
      {
        minutes: mins1,
        color: 'rgba(100,149,237,0.3)',
        type: 'Productive'
      },
      {
        minutes: mins0,
        color: 'rgba(160,82,45,0.4)',
        type: 'Maintenance'
      },
      {
        minutes: mins1n,
        color: 'rgba(255,105,180,0.6)',
        type: 'Distracting'
      },
      {
        minutes: mins2n,
        color: 'rgba(255,0,0,0.4)',
        type: 'Very Distracting'
      },
      {
        minutes: minsP,
        color: 'rgba(128,128,128,0.4)',
        type: 'Personal'
      },
      {
        minutes: minsW,
        color: 'rgba(255,165,0,0.5)',
        type: 'Workout'
      }
    )

    var offTrackMinsHappenedCat =
      24 * 60 -
      dailyPieCat.reduce(function(cnt, o) {
        return cnt + o.minutes
      }, 0)

    if (offTrackMinsHappenedCat > 0) {
      dailyPieCat.push({
        minutes: offTrackMinsHappenedCat,
        color: 'white',
        type: 'no tracking'
      })
    }

    return (
      <div>
        <FormControl className={classes.routineFixed}>
          <Select
            value={
              JSON.stringify({
                id: this.state.routine.id,
                name: this.state.routine.name,
                frequency: this.state.routine.frequency
              }) || ''
            }
            inputProps={{
              name: 'routine',
              id: 'routine',
              className: classes.textInput
            }}
            onChange={this.handleChange('routineId')}
            disableUnderline
          >
            {this.props.routinesQuery.allRoutines &&
              this.props.routinesQuery.allRoutines.map((e, index) => (
                <MenuItem
                  key={index}
                  value={JSON.stringify({
                    id: e.id,
                    name: e.name,
                    frequency: e.frequency
                  })}
                >
                  {e.name}
                </MenuItem>
              ))}
            <MenuItem value={'addRoutine'}>Add Routine</MenuItem>
          </Select>
        </FormControl>
        <IconButton
          className={classes.iconFixed}
          style={{ bottom: 10 }}
          size="small"
          onClick={() => this.handleOpenTrackers('manualAdd')}
        >
          <AddIcon className={classes.iconBtnCurrentBook} />
        </IconButton>
        <IconButton
          className={classes.iconFixed}
          style={{ bottom: 70 }}
          size="small"
          onClick={() => this.handleOpenTrackers('alchmeyTimer')}
        >
          <PlayArrowIcon className={classes.iconBtnCurrentBook} />
        </IconButton>
        <IconButton
          onClick={() => this.handleEnergyAdd(energyTrackerId)}
          className={classes.iconFixed}
          style={{ bottom: 130 }}
          size="small"
        >
          <EnergyIcon className={classes.iconBtnCurrentBook} />
        </IconButton>
        <div
          id="daily_timeline_chart_view"
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <div className={classes.divChartBurnDown}>
            {this.state.addErr ? (
              <div>{this.state.addErr}</div>
            ) : this.state.loadingCreate ? (
              <Loading />
            ) : this.state.loadingAddTo ? (
              <Loading />
            ) : this.state.loadingDel ? (
              <Loading />
            ) : this.state.loadingEvent ? (
              <Loading />
            ) : (
              <OrdinalFrame
                size={[this.props.width / 1.28, this.props.height / 1.28]}
                data={eventsDaily}
                rAccessor={d => new Date(d.startedAt)}
                //sortO={(a, b) => a > b}
                rExtent={[minTime, maxTime]}
                type={{
                  type: this.timelineDaily
                }}
                invertR={true}
                oPadding={this.props.width / 35}
                axis={[
                  {
                    orient: 'left',
                    ticks: 12,
                    tickFormat: d => (
                      <text
                        key={`tick-${d}`}
                        style={{
                          fill: '#cecece',
                          textAnchor: 'end',
                          fontSize: 10
                        }}
                        y={-2}
                        x={
                          moment(new Date(d)).format('h') === '12'
                            ? 164
                            : moment(new Date(d)).seconds() === 0 ? 150 : 157
                        }
                      >
                        {moment(new Date(d)).format('h') === '12'
                          ? moment(new Date(d)).format('h a')
                          : moment(new Date(d)).seconds() === 0
                            ? moment(new Date(d)).format('h')
                            : ''}
                      </text>
                    ),
                    tickValues: [
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('0')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('2')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('4')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('6')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('8')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('10')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('12')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('14')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('16')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('18')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('20')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('22')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('1')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('3')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('5')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('7')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('9')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('11')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('13')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('15')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('17')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('19')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('21')
                          .minute('0')
                          .second('0')
                      ),
                      new Date(
                        moment(moment(new Date(this.props.dayS)))
                          .hour('23')
                          .minute('0')
                          .second('0')
                      ),
                      moment(new Date(this.props.dayS)).format('l') !==
                      moment().format('l')
                        ? ''
                        : new Date(moment())
                    ],
                    baseline: false,
                    tickLineGenerator: ({ xy }) => (
                      <path
                        key={`tickLine-${xy.value}`}
                        style={{
                          stroke:
                            moment(new Date(xy.value)).seconds() !== 0
                              ? 'rgba(255,192,203,.3)'
                              : 'rgba(0,0,0,.02) '
                        }}
                        d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                          xy.y1
                        }L${xy.x1},${xy.y1}Z`}
                      />
                    )
                  }
                ]}
                margin={{
                  left: this.props.width / 7.5,
                  top: this.props.height / 24,
                  right: this.props.width / 10.6,
                  bottom: this.props.height / 9.6
                }}
                annotationSettings={{
                  layout: {
                    type: 'marginalia',
                    orient: 'right',
                    textPadding: this.props.width / 21
                  }
                }}
                hoverAnnotation={false}
              />
            )}
          </div>
          {this.state.apiErr ? (
            <div>{this.state.apiErr}</div>
          ) : (
            <div>
              <OrdinalFrame
                /* --- Data --- */
                data={dailyPie}
                /* --- Size --- */
                size={[350, 350]}
                margin={50}
                /* --- Layout --- */
                type="bar"
                projection="radial"
                dynamicColumnWidth={'minutes'}
                /* --- Process --- */
                oAccessor="type"
                /* --- Customize --- */
                style={d => ({
                  fill: d.color,
                  stroke: d.type === 'no tracking' ? 'lightgrey' : 'white'
                })}
                title="What good have I done to-day?"
                /* --- Annotate --- */
                oLabel={false}
              />
            </div>
          )}
          <div
            style={{
              textAlign: 'left',
              marginLeft: 100,
              marginTop: -30,
              marginBottom: 20
            }}
          >
            {dailyPie.map(
              r =>
                r.minutes > 5 && (
                  <span
                    key={r.type}
                    style={{
                      color: r.color
                    }}
                  >
                    {r.type}:{' '}
                    {parseInt(r.minutes, 10) < 60
                      ? parseInt(r.minutes, 10) + ' mins'
                      : parseInt(r.minutes, 10) % 60 === 0
                        ? Math.floor(parseInt(r.minutes, 10) / 60).toFixed(0) +
                          ' hrs'
                        : Math.floor(parseInt(r.minutes, 10) / 60).toFixed(0) +
                          ' hrs ' +
                          parseInt(r.minutes, 10) % 60 +
                          ' mins'}{' '}
                    <br />
                  </span>
                )
            )}
          </div>
          <div
            style={{
              textAlign: 'left',
              marginLeft: 100,
              marginTop: -30,
              marginBottom: 20
            }}
          >
            {apiDataRank.map(
              r =>
                r.mins > 5 && (
                  <span
                    key={r.type}
                    style={{
                      color: r.color
                    }}
                  >
                    {r.type}:{' '}
                    {parseInt(r.mins, 10) < 60
                      ? parseInt(r.mins, 10) + ' mins'
                      : parseInt(r.mins, 10) % 60 === 0
                        ? Math.floor(parseInt(r.mins, 10) / 60).toFixed(0) +
                          ' hrs'
                        : Math.floor(parseInt(r.mins, 10) / 60).toFixed(0) +
                          ' hrs ' +
                          parseInt(r.mins, 10) % 60 +
                          ' mins'}{' '}
                    <br />
                  </span>
                )
            )}
          </div>
          {this.state.apiTopErr ? (
            <div>{this.state.apiTopErr}</div>
          ) : (
            <div>
              <OrdinalFrame
                /* --- Data --- */
                data={dailyPieCat}
                /* --- Size --- */
                size={[350, 350]}
                margin={50}
                /* --- Layout --- */
                type="bar"
                projection="radial"
                dynamicColumnWidth={'minutes'}
                /* --- Process --- */
                oAccessor="type"
                /* --- Customize --- */
                style={d => ({
                  fill: d.color,
                  stroke: d.type === 'no tracking' ? 'lightgrey' : 'white'
                })}
                title="What good have I done to-day?"
                /* --- Annotate --- */
                oLabel={false}
              />
            </div>
          )}
          <div
            style={{
              textAlign: 'left',
              marginLeft: 100,
              marginTop: -30,
              marginBottom: 20
            }}
          >
            {dailyPieCat.map(
              (r, index) =>
                r.minutes > 5 && (
                  <span
                    key={index}
                    style={{
                      color: r.color
                    }}
                  >
                    {r.type}:{' '}
                    {parseInt(r.minutes, 10) < 60
                      ? parseInt(r.minutes, 10) + ' mins'
                      : parseInt(r.minutes, 10) % 60 === 0
                        ? Math.floor(parseInt(r.minutes, 10) / 60).toFixed(0) +
                          ' hrs'
                        : Math.floor(parseInt(r.minutes, 10) / 60).toFixed(0) +
                          ' hrs ' +
                          parseInt(r.minutes, 10) % 60 +
                          ' mins'}{' '}
                    <br />
                  </span>
                )
            )}
          </div>
          <div
            style={{
              textAlign: 'left',
              marginLeft: 100,
              marginTop: -30,
              marginBottom: 20
            }}
          >
            {apiDataRankTop.map(
              r =>
                r.mins > 5 && (
                  <span
                    key={r.type}
                    style={{
                      color: r.color
                    }}
                  >
                    {r.type}:{' '}
                    {parseInt(r.mins, 10) < 60
                      ? parseInt(r.mins, 10) + ' mins'
                      : parseInt(r.mins, 10) % 60 === 0
                        ? Math.floor(parseInt(r.mins, 10) / 60).toFixed(0) +
                          ' hrs'
                        : Math.floor(parseInt(r.mins, 10) / 60).toFixed(0) +
                          ' hrs ' +
                          parseInt(r.mins, 10) % 60 +
                          ' mins'}{' '}
                    <br />
                  </span>
                )
            )}
          </div>
        </div>
        <EventViewModal
          open={this.state.OpenView}
          onClose={this.handleCloseView}
          event={this.state.event}
          date={this.props.dayS}
        />

        <TrackersModal
          open={this.state.OpenTrackers}
          onClose={this.handleCloseTrackers}
          date={this.props.dayS}
          start={maxTimeHappened}
          origin={this.state.origin}
        />
        <RoutinesModal
          open={this.state.OpenRoutines}
          onClose={this.handleCloseRoutines}
        />
        <EventEditModal
          open={this.state.OpenAdd}
          openTimer={this.state.OpenTimer}
          onClose={this.handleCloseAdd}
          event={this.state.event}
          action={'add'}
          origin={this.state.origin}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyTimelineDaily.js